module.exports = __webpack_public_path__ + "static/media/galgotia_logo_2.46e353c6.jpeg";